import { RatingOfferedEntry } from 'lib-shared-legacy-types';

import { getLogEntryAuthorName, LogEntry } from './logEntry';
import { UserLink } from './userLink/userLink';

type RatingOfferedProps = {
  entry: RatingOfferedEntry;
};

export const RatingOffered = ({ entry }: RatingOfferedProps): JSX.Element => {
  const agentName = getLogEntryAuthorName({
    ...entry,
    author: entry.agent,
  });
  const agentLink = <UserLink userId={entry.agent.id}>{agentName}</UserLink>;

  const userName = getLogEntryAuthorName({ ...entry, author: entry.user });
  const userLink = <UserLink userId={entry.user.id}>{userName}</UserLink>;

  const text = (
    <>
      Conversation rating is offered to customer {userLink} for agent{' '}
      {agentLink}
    </>
  );

  return <LogEntry entry={entry} text={text} />;
};
